import React, { useMemo } from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

export type ICheckBoxListProps = {
	name: string;
	keyExpr: string;
	displayExpr: string;
	displaySubExpr?: string;
	dataSource: any[];
	selectedValue: any[];
	onSelectionChanged: (values: any[]) => void;
	error?: string;
	sizeClass?: 'xs' | 'sm' | 'md' | 'lg';
	helpBlock?: string;
};

export const CheckBoxList = (props: ICheckBoxListProps) => {
	const { error, name, sizeClass, helpBlock, dataSource, selectedValue, onSelectionChanged, keyExpr, displayExpr, displaySubExpr } = props;
	const showError = !!error;

	const selectedValueString = useMemo(() => {
		return selectedValue?.map((x: any) => x.toString()) || [];
	}, [selectedValue]);

	return (
		<div className="space-y-4">
			{showError && <p className="text-sm font-medium text-destructive">{error}</p>}
			{helpBlock && <p className="text-sm text-muted-foreground" dangerouslySetInnerHTML={{ __html: helpBlock }} />}
			<ul className="flex flex-col gap-3 w-full">
				{dataSource &&
					dataSource.map((item, index) => {
						const key = item[keyExpr].toString();
						const isChecked = selectedValueString.includes(key);
						const id = `checkbox-${key}_${index}`;
                        
						return (
							<li key={`${key}_${index}`}>
								<div className="flex flex-row items-start space-x-3 space-y-0 rounded-md border p-4 hover:bg-muted/50 transition-colors">
									<Checkbox
										id={id}
										name={name}
										value={key}
										checked={isChecked}
										onCheckedChange={(checked) => {
											const valueCopy = [...selectedValueString];
											const existIndex = valueCopy.indexOf(key);

											if (checked) {
												if (existIndex === -1) {
													valueCopy.push(key);
												}
											} else {
												if (existIndex > -1) {
													valueCopy.splice(existIndex, 1);
												}
											}
											onSelectionChanged(valueCopy);
										}}
									/>
									<Label htmlFor={id} className="flex flex-col font-normal w-full cursor-pointer">
										<div className="flex flex-col">
											<span className="text-base font-medium leading-none">{item[displayExpr]}</span>
											{displaySubExpr && <span className="text-sm text-muted-foreground mt-1">{item[displaySubExpr]}</span>}
										</div>
									</Label>
								</div>
							</li>
						);
					})}
			</ul>
		</div>
	);
};
